<template><warehouse-operation-page kind="writeOff" /></template>
<script>import WarehouseOperationPage from './WarehouseOperationPage.vue'; export default { name: 'WarehouseWriteOffOperation', components: { WarehouseOperationPage } }</script>
